import React from "react";
import { Link } from "react-router-dom";
import "../css/privacy.scss";

function Faqs() {
  return (
    <main id="main" className="main">
      <div className="shopify-policy__container">
        <div className="shopify-policy__title"><h1>Frequently asked questions</h1></div>
        <div className="shopify-policy__body"><div className="rte">
          <h2>What does slayfulpawsco sell?</h2>
          <p>We offer writing tools, notebooks, glass pens, stamps, and small desk accessories. Product pages list the available size, color, material, and care details.</p>
          <h2>Are the product photos original?</h2>
          <p>Yes. Images on this site were created specifically for slayfulpawsco to show each product concept from different angles. Colors can still vary slightly by screen.</p>
          <h2>How do I choose an option?</h2>
          <p>Choose the available color and size on the product page before adding the item to your cart. The selected options appear in your cart for review.</p>
          <h2>When will my order ship?</h2>
          <p>Processing times and delivery expectations are described in our <Link to="/shipping">Shipping Policy</Link>. Transit time begins after an order has been processed.</p>
          <h2>Can I return an item?</h2>
          <p>Eligibility, time limits, and return instructions are set out in our <Link to="/returns">Return Policy</Link>. Contact us before sending anything back.</p>
          <h2>How can I contact you?</h2>
          <p>Email <a href="mailto:phase@slayfulpawsco.cloud">phase@slayfulpawsco.cloud</a> or use the <Link to="/contact">contact form</Link>. Include your order number when asking about an existing order.</p>
        </div></div>
      </div>
    </main>
  );
}

export default Faqs;
